/**
 * Pedidos en línea / web: comprobante revisado por staff antes de marcar PAGADO.
 * Alineado con `factura_es_pedido_online_pago_diferido` en la migración SQL (prefijo WEB- o FORM- en número).
 */
export function facturaEsPedidoOnlineVerificable(f: { numero?: string | null }): boolean {
  const n = (f.numero || '').trim().toUpperCase();
  return n.startsWith('WEB-') || n.startsWith('FORM-');
}
